// extracted by mini-css-extract-plugin
export default {"message":"stub-page-message_message__EB6hx","title":"stub-page-message_title__fB5Ty"};